import styled from 'styled-components';

import { gridSizes } from 'utils/style';
import DatesRangeSelector from 'components/form/RecurringForm/components/DatesRangeSelector/container';

export default styled(DatesRangeSelector)`
  .fields-container {
    width: 100%;
    display: flex;
    gap: ${gridSizes('M')};

    .error {
      border: 1px solid red;
    }

    .not-error {
      border: 1px solid transparent;
    }

    & > div {
      grid-column: span 3;
      -ms-grid-column: 1;
      -ms-grid-column-span: 6;
      position: relative;
    }
  }
`;
